// import React, { useEffect, useRef } from "react";
// import "./home.css";
// import Banner from "../../components/banner/Banner";
// import Fe1 from "../../assets/fe1.png";
// import Fe2 from "../../assets/fe2.png";
// import Fe3 from "../../assets/fe3.png";
// import Fe4 from "../../assets/fe4.png";
// import Card1 from "../../assets/card1.png";
// import Card2 from "../../assets/card2.png";
// import Card3 from "../../assets/card3.png";
// import Orange from '../../assets/orange.png'
// import Litchi from '../../assets/litchi.png'
// import Mojito from '../../assets/mojito.png'
// import Ice from '../../assets/ice.png'
// import { gsap } from "gsap";


// const Home = () => {
//   const sectionRef = useRef(null);
//   const iceRef = useRef(null);

//   // useEffect(() => {
//   //   // Section Entry Animation
//   //   gsap.from(".bottle-container", { y: "0", delay: 0.5, opacity: 1, duration: 1 });
//   //   // Floating Effect for Images
//   //   gsap.to(".bottle-container img", {
//   //     x: "random(-20, 20)",
//   //     y: "random(-20, 20)",
//   //     zIndex: 22,
//   //     duration: 2,
//   //     ease: "none",
//   //     yoyo: true,
//   //     repeat: -1,
//   //   });
//   //   // Ice Animation
//   // }, []);
//   useEffect(() => {
//     // Entry Animation with Flip Effect
//     gsap.from(".bottle-container img", {
//       y: 100, // Niche se upar aayega
//       opacity: 1,
//       rotateY: 180, // Flip karega
//       duration: 1.5,
//       stagger: 0.2, // Ek ek karke aayega
//       ease: "power3.out",
//     });

//     // Floating Effect for Images
//     gsap.to(".bottle-container img", {
//       x: "random(-20, 20)",
//       y: "random(-20, 20)",
//       rotateY: "random(-10, 10)", // Thoda 3D effect
//       duration: 2,
//       ease: "none",
//       yoyo: true,
//       repeat: -1,
//     });

//   }, []);
//   return (
//     <div>
//       <Banner />
//       <section className="section_padding feature">
//         <div className="key-points">
//           <img src={Fe1} alt="" />
//           <h4>Electrolytes</h4>
//           <p>Stay hydrated and energized throughout the day.</p>
//         </div>
//         <div className="key-points">
//           <img src={Fe2} alt="" />
//           <h4>Essential Vitamins </h4>
//           <p>
//             Boost metabolism, support immunity, and promote overall wellness.
//           </p>
//         </div>
//         <div className="key-points">
//           <img src={Fe3} alt="" />
//           <h4>0 Sugar, 0 Calories</h4>
//           <p>Guilt-free refreshment with no sugar crashes</p>
//         </div>
//         <div className="key-points">
//           <img src={Fe4} alt="" />
//           <h4>No Preservatives</h4>
//           <p>Clean, pure hydration without artificial additives</p>
//         </div>
//       </section>
//       <section className="comparison-container section_padding">
//         <h2 className="comparison-heading">Why Choose Fusion?</h2>
//         <p className="comparison-subheading">
//           Compare Fusion Drink With Plain Water And Sugary Soft Drinks In A
//           Simple Table Or Graphic.
//         </p>
//         <div className="table-container">
//           <table className="comparison-table">
//             <thead>
//               <tr>
//                 <th></th>
//                 <th>Plain Water</th>
//                 <th>Sugary Soft Drinks</th>
//                 <th className="highlight">Fusion Drink</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td className="bold">Hydration</td>
//                 <td>Yes</td>
//                 <td>Partial (Due To Sugar)</td>
//                 <td className="highlight">Yes (Plus Electrolytes)</td>
//               </tr>
//               <tr>
//                 <td className="bold">Flavor</td>
//                 <td>None</td>
//                 <td>Yes (But Artificial)</td>
//                 <td className="highlight">Natural Fruit Flavors</td>
//               </tr>
//               <tr>
//                 <td className="bold">Sugar/Calories</td>
//                 <td>0 Sugar, 0 Cal</td>
//                 <td>High Sugar, High Cal</td>
//                 <td className="highlight">0 Sugar, 0 Cal</td>
//               </tr>
//               <tr>
//                 <td className="bold">Vitamins</td>
//                 <td>None</td>
//                 <td>Rarely (If Fortified)</td>
//                 <td className="highlight">B3, B5, B6, B7</td>
//               </tr>
//               <tr>
//                 <td className="bold">Preservatives</td>
//                 <td>None</td>
//                 <td>Common</td>
//                 <td className="highlight">0 Preservatives</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </section>
//       <section className="cards-cont section_padding">
//         <div className="card-section">
//           <div className="card">
//             <h4>Pre/Post Workout</h4>
//             <img src={Card1} alt="" />
//             <p>
//               Replenish electrolytes and boost energy without sugar crashes.
//               Stay strong, stay hydrated!
//             </p>
//           </div>
//           <div className="card">
//             <h4>On-the-Go</h4>
//             <img src={Card2} alt="" />
//             <p>
//               Light, refreshing, and energizing—perfect for busy lifestyles
//               without the downsides of soft drinks.
//             </p>
//           </div>
//           <div className="card">
//             <h4>Daily Hydration</h4>
//             <img src={Card3} alt="" />
//             <p>
//               A flavorful alternative to water, keeping you refreshed and
//               focused throughout the day.
//             </p>
//           </div>
//         </div>
//         <p className="subtitle-bottom">Fusion Drink – Beyond Water. Better Than Soft Drinks</p>
//       </section>
//       <section className="section_padding testimonial-section">
//          <h2>What Our Customers Say</h2>
//          <div className="testimonial">
//             <div className="testimonial-card">
//                <div className="top">
//                  <img src="" alt="" />
//                  <div className="bio">
//                     <h4>Rahul Mehta</h4>
//                     <p>Fitness Enthusiast</p>
//                  </div>
//                </div>
//                <p className="review">Fusion Drink is my go-to pre-workout hydration! It keeps me energized without the sugar rush. Perfect for my gym sessions!</p>
//             </div>
//             <div className="testimonial-card">
//                <div className="top">
//                  <img src="" alt="" />
//                  <div className="bio">
//                     <h4>Sneha Kapoor</h4>
//                     <p>Travel Blogger</p>
//                  </div>
//                </div>
//                <p className="review">I travel a lot, and carrying Fusion Drink makes hydration so much better. It's light, refreshing, and way better than sugary drinks.</p>
//             </div>
//             <div className="testimonial-card">
//                <div className="top">
//                  <img src="" alt="" />
//                  <div className="bio">
//                     <h4>Amit Sharma</h4>
//                     <p>Software Engineer</p>
//                  </div>
//                </div>
//                <p className="review">I used to get bored of plain water at work, but Fusion Drink changed that! It keeps me refreshed and focused throughout the day.</p>
//             </div>
//          </div>
//       </section>


//       {/* <section className="section_padding flavors-section" ref={sectionRef}>
//       <h2>Discover Our Flavors</h2>
//       <div className="bottle-container fruit-image">
//         <img src={Orange} alt="Orange" />
//         <img src={Litchi} alt="Litchi" />
//         <img src={Mojito} alt="Mojito" />
//       </div>
//       <img ref={iceRef} className="ice" src={Ice} alt="Ice" />
//     </section> */}

//       <section className="section_padding flavors-section">
//          <h2>Discover Our Flavors</h2>
//          <div className="bottle-container">
//             <img src={Orange} alt="" className="left"/>
//             <img src={Litchi} alt="" className="middle"/>
//             <img src={Mojito} alt="" className="right"/>
//          </div>
//          <img className="ice" src={Ice} alt="" />
//       </section>
//     </div>
//   );
// };

// export default Home;


import React, { useState, useRef, useEffect } from "react";
import "./home.css";
import Banner from "../../components/banner/Banner";
import Fe1 from "../../assets/fe1.png";
import Fe2 from "../../assets/fe2.png";
import Fe3 from "../../assets/fe3.png";
import Fe4 from "../../assets/fe4.png";
import Card1 from "../../assets/card1.png";
import Card2 from "../../assets/card2.png";
import Card3 from "../../assets/card3.png";
// import Orange from '../../assets/orange.png'
// import Litchi from '../../assets/litchi.png'
// import Mojito from '../../assets/mojito.png'
import Ice from '../../assets/ice.png'
import Orange from '../../assets/Bottle/Orange.png'
import Litchi from '../../assets/Bottle/Litchi.png'
import Mojito from '../../assets/Bottle/Mojito.png'
import TimerCarousel from "../../components/TimerCarousel/TimerCarousel";
import { gsap } from "gsap";
const Home = () => {
  const [themeColor, setThemeColor] = useState('var(--pear-background)');
  const orangeBottleRef = useRef(null);
  const litchiBottleRef = useRef(null);
  const mojitoBottleRef = useRef(null);

  // Callback to receive theme color from Banner
  const handleThemeChange = (color) => {
    setThemeColor(color);
  };

  useEffect(() => {
    // Entry Animation and effects for all bottles
    const bottles = [orangeBottleRef, litchiBottleRef, mojitoBottleRef];
    bottles.forEach((ref, i) => {
      if (ref.current) {
        gsap.from(ref.current, {
          y: 45,
          opacity: 0,
          scale: 0.7,
          rotateY: 45,
          duration: 2.2,
          ease: "power3.out",
          delay: i * 0.2,
        });
        // Floating effect
        gsap.to(ref.current, {
          y: "random(-20, 20)",
          rotateY: "random(-10, 10)",
          duration: 2,
          ease: "none",
          yoyo: true,
          repeat: -1,
          delay: 2.2 + i * 0.2,
        });
        // Blinking effect
        gsap.to(ref.current, {
          opacity: 0.2,
          duration: 0.5,
          repeat: -1,
          yoyo: true,
          ease: "power1.inOut",
          delay: 2.2 + i * 0.2,
        });
      }
    });
  }, []);

  return (
    <div >
      <Banner onThemeChange={handleThemeChange} />
      <section className="section_padding feature">
        <div className="key-points">
          <img src={Fe1} alt="" style={{ color: themeColor, transition: 'background 0.5s' }}/>
          <h4>Electrolytes</h4>
          <p>Stay hydrated and energized throughout the day.</p>
        </div>
        <div className="key-points">
          <img src={Fe2} alt="" />
          <h4>Essential Vitamins </h4>
          <p>
            Boost metabolism, support immunity, and promote overall wellness.
          </p>
        </div>
        <div className="key-points">
          <img src={Fe3} alt="" />
          <h4>0 Sugar, 0 Calories</h4>
          <p>Guilt-free refreshment with no sugar crashes</p>
        </div>
        <div className="key-points">
          <img src={Fe4} alt="" />
          <h4>No Preservatives</h4>
          <p>Clean, pure hydration without artificial additives</p>
        </div>
      </section>
      <section className="comparison-container section_padding">
        <h2 className="comparison-heading">Why Choose Fusion?</h2>
        <p className="comparison-subheading">
          Compare Fusion Drink With Plain Water And Sugary Soft Drinks In A
          Simple Table Or Graphic.
        </p>
        <div className="table-container">
          <table className="comparison-table">
            <thead>
              <tr>
                <th></th>
                <th>Plain Water</th>
                <th>Sugary Soft Drinks</th>
                <th className="highlight">Fusion Drink</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="bold">Hydration</td>
                <td>Yes</td>
                <td>Partial (Due To Sugar)</td>
                <td className="highlight">Yes (Plus Electrolytes)</td>
              </tr>
              <tr>
                <td className="bold">Flavor</td>
                <td>None</td>
                <td>Yes (But Artificial)</td>
                <td className="highlight">Natural Fruit Flavors</td>
              </tr>
              <tr>
                <td className="bold">Sugar/Calories</td>
                <td>0 Sugar, 0 Cal</td>
                <td>High Sugar, High Cal</td>
                <td className="highlight">0 Sugar, 0 Cal</td>
              </tr>
              <tr>
                <td className="bold">Vitamins</td>
                <td>None</td>
                <td>Rarely (If Fortified)</td>
                <td className="highlight">B3, B5, B6, B7</td>
              </tr>
              <tr>
                <td className="bold">Preservatives</td>
                <td>None</td>
                <td>Common</td>
                <td className="highlight">0 Preservatives</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className="cards-cont section_padding">
        <div className="card-section" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <TimerCarousel/>

          {/* <div className="card">
            <h4>Pre/Post Workout</h4>
            <img src={Card1} alt="" />
            <p>
              Replenish electrolytes and boost energy without sugar crashes.
              Stay strong, stay hydrated!
            </p>
          </div>
          <div className="card">
            <h4>On-the-Go</h4>
            <img src={Card2} alt="" />
            <p>
              Light, refreshing, and energizing—perfect for busy lifestyles
              without the downsides of soft drinks.
            </p>
          </div>
          <div className="card">
            <h4>Daily Hydration</h4>
            <img src={Card3} alt="" />
            <p>
              A flavorful alternative to water, keeping you refreshed and
              focused throughout the day.
            </p>
          </div> */}
        </div>
        <p className="subtitle-bottom">Fusion Drink – Beyond Water. Better Than Soft Drinks</p>
      </section>
      <section className="section_padding testimonial-section">
        <h2>What Our Customers Say</h2>
        <div className="testimonial">
          <div className="testimonial-card">
            <div className="top">
              <img src="" alt="" />
              <div className="bio">
                <h4>Rahul Mehta</h4>
                <p>Fitness Enthusiast</p>
              </div>
            </div>
            <p className="review">Fusion Drink is my go-to pre-workout hydration! It keeps me energized without the sugar rush. Perfect for my gym sessions!</p>
          </div>
          <div className="testimonial-card">
            <div className="top">
              <img src="" alt="" />
              <div className="bio">
                <h4>Sneha Kapoor</h4>
                <p>Travel Blogger</p>
              </div>
            </div>
            <p className="review">I travel a lot, and carrying Fusion Drink makes hydration so much better. It's light, refreshing, and way better than sugary drinks.</p>
          </div>
          <div className="testimonial-card">
            <div className="top">
              <img src="" alt="" />
              <div className="bio">
                <h4>Amit Sharma</h4>
                <p>Software Engineer</p>
              </div>
            </div>
            <p className="review">I used to get bored of plain water at work, but Fusion Drink changed that! It keeps me refreshed and focused throughout the day.</p>
          </div>
        </div>
      </section>
      {/* <section className="section_padding flavors-section">
        <h2>Discover Our Flavors</h2>
        <div className="bottle-container justify-content-center">
          <div className="">            <img src={Orange} alt="" />
          </div>
          <div className="">            <img src={Litchi} alt="" />
          </div>         <div className="">   <img src={Mojito} alt="" /></div>
        </div>
        <img className="ice" src={Ice} alt="" />
      </section> */}
      <section className="section_padding flavors-section">
        <h2>Discover Our Flavors</h2>
        <div className="bottle-container">
          <div className="bottle left">
            <img ref={orangeBottleRef} src={Orange} alt="Orange" />
          </div>
          <div className="bottle center">
            <img ref={litchiBottleRef} src={Litchi} alt="Litchi" />
          </div>
          <div className="bottle right">
            <img ref={mojitoBottleRef} src={Mojito} alt="Mojito" />
          </div>
        </div>
        <img className="ice" src={Ice} alt="Ice" />
      </section>

    </div>
  );
};

export default Home;
